import { brandAssets, siteOrigin } from "content/site";

const seo = {
	title: "Truss Security",
	description:
		"The Truss Website and Whitepaper layout the primary mission and focus of the Truss Protocol and Truss Marketplace through the establishment of a decentralized autonomous security platform.",
	"og:title": "Truss",
	"og:description": "Truss Security establishes a decentralized autonomous security platform.",
	"og:image": `${siteOrigin}${brandAssets.icon92}`,
	favicon_32px: `${siteOrigin}${brandAssets.favicon}`,
	favicon_apple_152px: `${siteOrigin}${brandAssets.icon92}`,
	favicon_win10_270px: `${siteOrigin}${brandAssets.icon92}`,
	background_win10: "#ffffff",
};

export default {
	pages: {
		root: {
			id: "root",
			pageUrl: "root",
			name: "root",
			children: ["64972fbb588b2d0019591bb6", "64972fbb588b2d0019591bb9", "649730a572a6d3001824752b", "6498de6d032e8d0018863197"],
		},
		"64972fbb588b2d0019591bb6": {
			id: "64972fbb588b2d0019591bb6",
			name: "404",
			pageUrl: "404",
		},
		"64972fbb588b2d0019591bb9": {
			id: "64972fbb588b2d0019591bb9",
			name: "About",
			pageUrl: "index",
		},
		"649730a572a6d3001824752b": {
			id: "649730a572a6d3001824752b",
			pageUrl: "whitepaper",
			name: "Whitepaper",
		},
		"6498de6d032e8d0018863197": {
			id: "6498de6d032e8d0018863197",
			pageUrl: "coming-soon",
			name: "Coming Soon",
		},
	},
	mode: "production",
	projectType: "create-react-app",
	site: {
		styles: {},
		seo,
	},
};
